/**
 * Main JavaScript file for the theme
 * Note: All libraries are loaded via Gulp concatenation from node_modules
 */

// Wait for the DOM to be fully loaded
document.addEventListener('DOMContentLoaded', () => {
	// Mobile menu toggle
	const menuToggle = document.querySelector('.menu-toggle');
	const mainNavigation = document.querySelector('.main-navigation');

	if (menuToggle) {
		menuToggle.addEventListener('click', () => {
			mainNavigation.classList.toggle('toggled');

			if (mainNavigation.classList.contains('toggled')) {
				menuToggle.setAttribute('aria-expanded', 'true');
			} else {
				menuToggle.setAttribute('aria-expanded', 'false');
			}
		});
	}

	// Initialize Swiper sliders
	initializeSwipers();

	// Initialize Fancybox
	initializeFancybox();

	// Smooth scroll for anchor links
	document.querySelectorAll('a[href^="#"]:not([href="#"])').forEach((anchor) => {
		anchor.addEventListener('click', function (e) {
			const target = document.querySelector(this.getAttribute('href'));

			if (target) {
				e.preventDefault();

				window.scrollTo({
					top: target.offsetTop - 100,
					behavior: 'smooth',
				});
			}
		});
	});

	// Add responsive table wrapper
	document.querySelectorAll('table').forEach((table) => {
		if (!table.closest('.table-responsive')) {
			const wrapper = document.createElement('div');
			wrapper.className = 'table-responsive';
			table.parentNode.insertBefore(wrapper, table);
			wrapper.appendChild(table);
		}
	});

	// Add external link icon and target="_blank"
	document.querySelectorAll('a').forEach((link) => {
		const url = link.href;

		if (url && url.indexOf(window.location.hostname) === -1 && url.startsWith('http')) {
			link.setAttribute('target', '_blank');
			link.setAttribute('rel', 'noopener noreferrer');

			// Only add icon if it doesn't contain an image
			if (!link.querySelector('img')) {
				link.classList.add('external-link');
			}
		}
	});
});

/**
 * Initialize Fancybox
 */
function initializeFancybox() {
	// Check if Fancybox is available (it should be loaded via Gulp)
	if (typeof window.Fancybox === 'undefined') {
		console.warn('Fancybox is not loaded');
		return;
	}

	// Bind Fancybox to all images with data-fancybox attribute
	window.Fancybox.bind('[data-fancybox]', {
		// Global options
		Toolbar: {
			display: {
				left: ['infobar'],
				middle: ['zoomIn', 'zoomOut', 'toggle1to1', 'rotateCCW', 'rotateCW', 'flipX', 'flipY'],
				right: ['slideshow', 'thumbs', 'close'],
			},
		},
		Thumbs: {
			autoStart: false,
		},
	});

	// Bind Fancybox to WordPress galleries
	window.Fancybox.bind('.gallery a', {
		groupAll: true, // Group all gallery images together
	});

	// Bind Fancybox to WordPress attachment pages
	window.Fancybox.bind('.wp-block-image a', {
		groupAll: true,
	});

	// Custom Fancybox for videos
	window.Fancybox.bind('[data-fancybox-video]', {
		// Video-specific options
	});
}

/**
 * Initialize all Swiper sliders on the page
 */
function initializeSwipers() {
	// Check if Swiper is available (it should be loaded via Gulp)
	if (typeof window.Swiper === 'undefined') {
		console.warn('Swiper is not loaded');
		return;
	}
	// Cards/Content Slider
	const cardsSlider = document.querySelector('.testimonial-slider');
	if (cardsSlider) {
		const swiperInstance = new window.Swiper('.testimonial-slider', {
			loop: true,
			spaceBetween: 30,
			slidesPerView: 1,
			autoplay: {
				delay: 10000,
				disableOnInteraction: false,
				pauseOnMouseEnter: false,
			},
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
			},
			navigation: {
				nextEl: '.button-next',
				prevEl: '.button-prev',
			},
			breakpoints: {
				991: {
					slidesPerView: 2,
				},
			},
		});

		if (swiperInstance.autoplay && swiperInstance.autoplay.running) {
			console.log('Testimonial slider autoplay is running');
		} else {
			console.warn('Testimonial slider autoplay failed to start');
		}
	}
}

/**
 * Utility function to create a basic slider programmatically
 * @param {string} selector - CSS selector for the slider container
 * @param {object} options - Swiper options
 */
function createSwiper(selector, options = {}) {
	const element = document.querySelector(selector);
	if (!element || typeof window.Swiper === 'undefined') {
		return null;
	}

	const defaultOptions = {
		loop: true,
		autoplay: {
			delay: 3000,
		},
		pagination: {
			el: '.swiper-pagination',
			clickable: true,
		},
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		breakpoints: {
			640: {
				slidesPerView: 1,
			},
			768: {
				slidesPerView: 2,
			},
			1024: {
				slidesPerView: 3,
			},
		},
	};

	const mergedOptions = Object.assign({}, defaultOptions, options);
	return new window.Swiper(selector, mergedOptions);
}

// Make functions available globally
window.createCustomSwiper = createSwiper;
window.initializeFancybox = initializeFancybox;

// Mobile Menu
document.addEventListener('DOMContentLoaded', function () {
	const menuToggle = document.querySelector('.navbar-toggler');
	const mainNav = document.querySelector('.main-navigation-wrapper');
	const dropdownToggles = document.querySelectorAll('.dropdown-toggle');

	// Mobile menu toggle
	if (menuToggle && mainNav) {
		menuToggle.addEventListener('click', function () {
			this.classList.toggle('active');
			mainNav.classList.toggle('mobile-active');
			document.body.classList.toggle('menu-open');
		});
	}

	// Dropdown toggles
	if (dropdownToggles) {
		dropdownToggles.forEach((toggle) => {
			toggle.addEventListener('click', function (e) {
				e.preventDefault();
				e.stopPropagation();

				// Toggle active state
				this.classList.toggle('active');

				// Find and toggle dropdown
				const dropdown = this.parentNode.querySelector('.menu-dropdown');
				if (dropdown) {
					dropdown.classList.toggle('show');
				}
			});
		});
	}

	// Close menu when clicking outside
	document.addEventListener('click', function (e) {
		if (window.innerWidth <= 1270) {
			if (!mainNav.contains(e.target) && !menuToggle.contains(e.target)) {
				mainNav.classList.remove('mobile-active');
				menuToggle.classList.remove('active');
				document.body.classList.remove('menu-open');
			}
		}
	});

	// Handle window resize
	let resizeTimer;
	window.addEventListener('resize', function () {
		clearTimeout(resizeTimer);
		resizeTimer = setTimeout(function () {
			if (window.innerWidth > 1270) {
				mainNav.classList.remove('mobile-active');
				menuToggle.classList.remove('active');
				document.body.classList.remove('menu-open');
				document.querySelectorAll('.menu-dropdown.show').forEach((dropdown) => {
					dropdown.classList.remove('show');
				});
			}
		}, 250);
	});
});

window.addEventListener('scroll', function () {
	const navbar = document.querySelector('.navbar');

	if (window.scrollY > 0) {
		navbar.classList.add('scrolled');
	} else {
		navbar.classList.remove('scrolled');
	}
});

jQuery(function ($) {
	var $hero = $('.hero');
	if (!$hero.length) return;

	var $video = $hero.find('.bg-video-el');
	if (!$video.length) return;

	var videoEl = $video.get(0);
	var prefersReduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

	var videoReady = false;
	var windowLoaded = false;

	function markReadyOnce() {
		if (!videoReady) {
			videoReady = true;
			maybeHideLoader();
		}
		if (!$hero.hasClass('is-video-ready')) {
			$hero.addClass('is-video-ready');
		}
	}

	function maybeHideLoader() {
		if (videoReady && windowLoaded) {
			$('#site-loader').fadeOut(800);
		}
	}

	// reveal video when ready
	$video.on('loadeddata canplay canplaythrough playing', function () {
		markReadyOnce();
	});

	// try autoplay (muted). If blocked or reduced motion, just pause
	function tryAutoplay() {
		if (prefersReduce) {
			videoEl.pause();
			return;
		}
		var p = videoEl.play();
		if (p && typeof p.then === 'function') {
			p.then(function () {
				markReadyOnce(); // video actually started
			}).catch(function () {
				videoEl.pause();
				markReadyOnce(); // still mark as ready to unblock loader
			});
		}
	}
	tryAutoplay();

	// pause when scrolled out of view
	if ('IntersectionObserver' in window) {
		var io = new IntersectionObserver(
			function (entries) {
				entries.forEach(function (e) {
					if (!e.isIntersecting && !videoEl.paused) {
						videoEl.pause();
					}
				});
			},
			{ threshold: 0.1 }
		);
		io.observe($hero.get(0));
	}

	// track when window finished loading
	$(window).on('load', function () {
		windowLoaded = true;
		maybeHideLoader();
	});
});

(function () {
	const buttons = document.querySelectorAll('.js-team-card');
	let activeCard = null;

	buttons.forEach((btn) => {
		btn.addEventListener('click', (e) => {
			// if the click originated from a link, bail out
			if (e.target.closest('a')) {
				return; // let the link work normally
			}

			e.preventDefault(); // prevent accidental form submission

			const card = btn.querySelector('.team-card');
			if (!card) return;

			const isSameCard = activeCard === card;

			// deactivate other card
			if (activeCard && !isSameCard) {
				activeCard.classList.remove('is-active');
				activeCard = null;
			}

			// toggle current card
			if (isSameCard) {
				card.classList.remove('is-active');
				activeCard = null;
			} else {
				card.classList.add('is-active');
				activeCard = card;
			}
		});
	});
})();
